<template>
  <div class="plv-ia-aq-ongoing">
    {{ t('plvIA.answerQuickly.currently') }}
    <span class="plv-ia-aq-ongoing__num">{{ answerNum }}</span>{{ t('plvIA.answerQuickly.respond') }}
    <div class="plv-ia-aq-ongoing__time">
      <span class="plv-ia-aq-ongoing__time__t">{{ overTime }}</span>{{ t('plvIA.answerQuickly.secondsShorthand') }}
    </div>{{ t('plvIA.answerQuickly.endAutomaticallyTips') }}
    <div class="plv-ia-aq-ongoing__btn">
      <button class="plv-ia-btn-new plv-ia-btn-orange" @click="handleClickOverBtn">{{ t('plvIA.answerQuickly.endNow') }}</button>
    </div>
  </div>
</template>
<script>
import Locale from '@/mixins/locale';
export default {
  mixins: [Locale],
  props: {
    overTime: {
      type: Number,
      default: 30,
    },
    answerNum: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    handleClickOverBtn() {
      this.$emit('stop');
    }
  }
};
</script>

<style lang="scss">
@import './mixins.scss';

.plv-ia-aq-ongoing {
  color: #606266;
  font-size: 14px;
  @include mid;
  position: absolute;
  text-align: center;
  &__time {
    $size: 96px;
    width: $size;
    height: $size;
    color: #2196f3;
    background: rgba(229, 242, 254, 1);
    text-align: center;
    border-radius: 50%;
    @include mid_x;
    margin: 15px 0 14px 0;
    &__t {
      font-size: 32px;
      line-height: $size;
    }
  }
  &__btn {
    text-align: center;
    padding-top: 40px;
  }
}
</style>
